import IncomeReport from './pages/dashboard/financial-reports/income-report';
import BalanceReports from './pages/dashboard/financial-reports/balance-reports';
import * as React from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { SignIn } from './pages/sign-in/sign-in';
import { LoginWithPassword } from './pages/sign-in/login-with-password/login-with-passowrd';
import { Dashboard } from './pages/dashboard/dashboard';
import { Users } from './pages/dashboard/users/users';
import { isLogin } from 'apis/api';
import { OrdersTransactions } from './pages/dashboard/orders-transactions/orders-transactions';
import { EditUser } from './pages/dashboard/users/edit/edit';
import { ReferralInfos } from './pages/dashboard/referral-infos/referral-infos';
import { ReferralWithdrawals } from './pages/dashboard/referral-withdrals/referral-withdrawals';
import { ReferralActions } from './pages/dashboard/referral-actions/referral-actions';
import { Roles } from './pages/dashboard/roles/roles';
import { MediaSurveys } from './pages/dashboard/media-surveys/media-surveys';
import { SurveyDetails } from './pages/dashboard/media-surveys/edit/edit-survey';
import { AuthMediasWaitingForAdmin } from './pages/dashboard/media-surveys/waiting-for-admin/auth-medias-waiting';
import { CreateRole } from './pages/dashboard/roles/create/create';
import { EditRole } from './pages/dashboard/roles/edit/edit';
import { Code } from './pages/sign-in/code/code';
import { BankAccounts } from './pages/dashboard/bank-accounts/bank-accounts';
import { CreateBankAccount } from './pages/dashboard/bank-accounts/create/create-bank-account';
import { SearchOrderByTrackingCode } from './pages/dashboard/order-by-tracking-code/order-by-tracking-code';
import { SearchUserByPhoneNumber } from './pages/dashboard/user-by-phone-number/user-by-phone-number';
import { SearchGatewayTransactionByTrackingCode } from './pages/dashboard/gateway-transactions-by-tracking-code/gateway-transactions-by-tracking-code';
import { GatewayTransactions } from './pages/dashboard/gateway-transactions/gateway-transactions';
import { TrackVoucher } from './pages/dashboard/track-voucher/track-voucher';
import { Orders } from './pages/dashboard/orders/orders';
import { Transactions } from './pages/dashboard/transactions/transactions';
import { AuditLog } from './pages/dashboard/audit-log/audit-log';
import { AuditLogById } from './pages/dashboard/audit-log/get-by-id/audit-log-get-by-id';
import { Overview } from './pages/dashboard/overview/overview';
import { VoucherPerfectmoney } from './pages/dashboard/voucher-perfectmoney/voucher-perfectmoney';
import { BankAccountStatement } from './pages/dashboard/bank-account-statement/bank-account-statement';
import { SystemOfflineDepositSettings } from './pages/dashboard/system-offline-deposit-settings/system-offline-deposit-settings';
import { PaymentGatewaysSettings } from './pages/dashboard/settings/payment-gateways/payment-gateways';
import { FinancialSettings } from './pages/dashboard/settings/financial/financial';
import { IntegrationsSettings } from './pages/dashboard/settings/integrations/integrations';
import { AuthenticationSettings } from './pages/dashboard/settings/authentication/authentication';
import { FiatTable } from './pages/dashboard/fiat/fiat';
import { SearchOrderWithKeyword } from './pages/dashboard/search-order-with-keyword/order-with-keyword';
import { UsersSavedWallets } from './pages/dashboard/users-saved-wallets/users-saved-wallets';
import { AddWallet } from './pages/dashboard/users-saved-wallets/add/add';
import { UsersSavedIBans } from './pages/dashboard/users-saved-ibans/users-saved-ibans';
import { AddIBan } from './pages/dashboard/users-saved-ibans/add/add';
import { BuysWaitingForAcceptReceipt } from './pages/dashboard/orders-transactions/waiting-for-accept-receipt/buy/buy';
import { SellsWaitingForAcceptReceipt } from './pages/dashboard/orders-transactions/waiting-for-accept-receipt/sell/sell';
import { TradesWaitingForAcceptReceipt } from './pages/dashboard/orders-transactions/waiting-for-accept-receipt/trade/trade';
import { Topics } from './pages/dashboard/content-management/topics/topics';
import { AddTopic } from './pages/dashboard/content-management/topics/add/add-topic';
import { EditTopic } from './pages/dashboard/content-management/topics/edit/edit-topic';
import { ManageMarkets } from './pages/dashboard/content-management/manage-markets/manage-markets';
import { EditMarket } from './pages/dashboard/content-management/manage-markets/edit/edit-market';
import { Categories } from './pages/dashboard/content-management/categories/categories';
import { AddCategory } from './pages/dashboard/content-management/categories/add/add-category';
import { EditCategory } from './pages/dashboard/content-management/categories/edit/edit-category';
import { Contents } from './pages/dashboard/content-management/contents/contents';
import { AddContent } from './pages/dashboard/content-management/contents/add/add-content';
import { EditContent } from './pages/dashboard/content-management/contents/edit/edit-content';
import { LossAndProfitReportPage } from './pages/dashboard/loss-and-profit/loss-and-profit';
import { BalancerTransactions } from './pages/dashboard/balancer-transactions/balancer-transactions';
import { EditBalancerTransactionPage } from './pages/dashboard/balancer-transactions/edit/edit';
import { UtopiaVouchers } from './pages/dashboard/utopia-vouchers/utopia-vouchers';
import { DepositUtopia } from './pages/dashboard/deposit-utopia/deposit-utopia';
import { SellUtopiaManual } from './pages/dashboard/sell-utopia-manual/sell-utopia-manual';
import { OldTxIds } from './pages/dashboard/old-tx-ids/old-tx-ids';
import { CreateOldTxId } from './pages/dashboard/old-tx-ids/create/create';
import { CampaignReports } from './pages/dashboard/campaign-reports/campaign-reports';
import { KuCoinHistoryPage } from './pages/dashboard/kucoin-history/kucoin-history';
import { CreatePopUp } from './pages/dashboard/popups/add/add';
import { UpdatePopUp } from './pages/dashboard/popups/edit/edit';
import { PopUps } from './pages/dashboard/popups/popups';
import { WorldCupTeams } from './pages/dashboard/world-cup-teams/world-cup-teams';
import { WorldCupParticipants } from './pages/dashboard/world-cup-participants/world-cup-participants';
import { UserScoreLogs } from './pages/dashboard/user-score-logs/user-score-logs';
import { UserScoreDetail } from './pages/dashboard/user-score-logs/detail/user-score-detail';
import { IrtWithdrawalsWaitingForAdmin } from './pages/dashboard/irt-withdrawals-waiting/irt-withdrawals-waiting';
import { UsersBalances } from './pages/dashboard/users-balances/users-balances';
import { UsersBalanceBySymbol } from './pages/dashboard/users-balances/by-symbol/users-balance-by-symbol';
import { SendBulkSms } from './pages/dashboard/send-bulk-sms/send-bulk-sms';
import { MarketingActivities } from './pages/dashboard/marketing/activities/activities';
import { CallTasks } from './pages/dashboard/marketing/call-tasks/call-tasks';
import { MarketingCampaigns } from './pages/dashboard/marketing/campaigns/campaigns';
import { CampaignReport } from './pages/dashboard/marketing/campaigns/campaign-report';
import { GoldUpgradeCandidates } from './pages/dashboard/marketing/gold-upgrade/gold-upgrade';

export const PmxDashboard: React.FC = () => {
    const [value, setValue] = React.useState<string>('');
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLogin() && !window.location.pathname.includes('signin')) navigate('/signin');

        // const path = location.pathname;
        // var item = SidebarItems.filter(
        //   (q) => q.link.toLowerCase() === path.toLowerCase()
        // );
        // if (item.length === 0)
        //   item = SidebarItems.filter((q) =>
        //     q.secondaryLinks?.filter((w) => w.startsWith(path))
        //   );

        // dispatch(setMenuItem(item[0].id));
    }, []);

    return (
        <Routes>
                    <Route path="/dashboard/income-report" element={<Dashboard children={<IncomeReport />} />} />
                    <Route path="/dashboard/balance-reports" element={<Dashboard children={<BalanceReports />} />} />

            <Route path="/signin">
                <Route path="" element={<SignIn children={<LoginWithPassword />} />} />
                <Route path="code" element={<SignIn children={<Code />} />} />
            </Route>
            <Route path="dashboard">
                <Route path="users">
                    <Route path="" element={<Dashboard children={<Users />} />} />
                    <Route path="edit/:id" element={<Dashboard children={<EditUser />} />} />
                </Route>
                <Route path="orders-transactions" element={<Dashboard children={<OrdersTransactions />} />} />
                <Route
                    path="orders-transactions/buys-waiting-for-admin"
                    element={<Dashboard children={<BuysWaitingForAcceptReceipt />} />}
                />
                <Route
                    path="orders-transactions/sells-waiting-for-admin"
                    element={<Dashboard children={<SellsWaitingForAcceptReceipt />} />}
                />
                <Route
                    path="orders-transactions/trades-waiting-for-admin"
                    element={<Dashboard children={<TradesWaitingForAcceptReceipt />} />}
                />
                <Route
                    path="transactions/irt-withdrawals-waiting-for-admin"
                    element={<Dashboard children={<IrtWithdrawalsWaitingForAdmin />} />}
                />
                <Route path="orders" element={<Dashboard children={<Orders />} />} />
                <Route path="transactions" element={<Dashboard children={<Transactions />} />} />
                <Route path="users-balances">
                    <Route path="" element={<Dashboard children={<UsersBalances />} />} />
                    <Route path=":symbol" element={<Dashboard children={<UsersBalanceBySymbol />} />} />
                </Route>
                <Route path={'users-saved-wallets'} element={<Dashboard children={<UsersSavedWallets />} />} />
                <Route path={'users-saved-wallets/add'} element={<Dashboard children={<AddWallet />} />} />
                <Route path={'users-saved-ibans'} element={<Dashboard children={<UsersSavedIBans />} />} />
                <Route path={'users-saved-ibans/add'} element={<Dashboard children={<AddIBan />} />} />
                <Route path="gateway-transactions" element={<Dashboard children={<GatewayTransactions />} />} />
                <Route path="voucher-perfectmoney" element={<Dashboard children={<VoucherPerfectmoney />} />} />
                <Route
                    path="search-gateway-transaction-by-tracking-code"
                    element={<Dashboard children={<SearchGatewayTransactionByTrackingCode />} />}
                />
                <Route
                    path="search-order-by-tracking-code"
                    element={<Dashboard children={<SearchOrderByTrackingCode />} />}
                />
                <Route path="search-order-by-keyword" element={<Dashboard children={<SearchOrderWithKeyword />} />} />
                <Route path="get-user-by-phone-number" element={<Dashboard children={<SearchUserByPhoneNumber />} />} />
                <Route path="referral-infos" element={<Dashboard children={<ReferralInfos />} />} />
                <Route path="kucoin-history" element={<Dashboard children={<KuCoinHistoryPage />} />} />
                <Route path="bank-accounts">
                    <Route path="" element={<Dashboard children={<BankAccounts />} />} />
                    <Route path="create" element={<Dashboard children={<CreateBankAccount />} />} />
                </Route>
                <Route path="old-tx-ids">
                    <Route path="" element={<Dashboard children={<OldTxIds />} />} />
                    <Route path="create" element={<Dashboard children={<CreateOldTxId />} />} />
                </Route>
                <Route path="campaign-reports" element={<Dashboard children={<CampaignReports />} />} />
                <Route path="bank-account-statement">
                    <Route path="" element={<Dashboard children={<BankAccountStatement />} />} />
                </Route>
                <Route path="referral-withdrawals" element={<Dashboard children={<ReferralWithdrawals />} />} />
                <Route path="referral-actions" element={<Dashboard children={<ReferralActions />} />} />
                <Route path="roles">
                    <Route path="" element={<Dashboard children={<Roles />} />} />
                    <Route path="create" element={<Dashboard children={<CreateRole />} />} />
                    <Route path="edit/:id" element={<Dashboard children={<EditRole />} />} />
                </Route>
                <Route path="content">
                    <Route path="topics">
                        <Route path="" element={<Dashboard children={<Topics />} />} />
                        <Route path="add" element={<Dashboard children={<AddTopic />} />} />
                        <Route path="edit/:id" element={<Dashboard children={<EditTopic />} />} />
                    </Route>
                    <Route path="manage-markets">
                        <Route path="" element={<Dashboard children={<ManageMarkets />} />} />
                        <Route path="edit/:id" element={<Dashboard children={<EditMarket />} />} />
                    </Route>
                    <Route path="categories">
                        <Route path="" element={<Dashboard children={<Categories />} />} />
                        <Route path="add" element={<Dashboard children={<AddCategory />} />} />
                        <Route path="edit/:id" element={<Dashboard children={<EditCategory />} />} />
                    </Route>
                    <Route path="contents">
                        <Route path="" element={<Dashboard children={<Contents />} />} />
                        <Route path="add" element={<Dashboard children={<AddContent />} />} />
                        <Route path="edit/:id" element={<Dashboard children={<EditContent />} />} />
                    </Route>
                </Route>
                <Route path="media-surveys">
                    <Route path="" element={<Dashboard children={<MediaSurveys />} />} />
                    <Route path="waiting-for-admin" element={<Dashboard children={<AuthMediasWaitingForAdmin />} />} />
                    <Route path="details/:id" element={<Dashboard children={<SurveyDetails />} />} />
                </Route>
                <Route path="audit-log">
                    <Route path="" element={<Dashboard children={<AuditLog />} />} />
                    <Route path="details/:id" element={<Dashboard children={<AuditLogById />} />} />
                </Route>
                <Route path={'overview'} element={<Dashboard children={<Overview />} />} />
                <Route path="popups">
                    <Route path="" element={<Dashboard children={<PopUps />} />} />
                    <Route path="add" element={<Dashboard children={<CreatePopUp />} />} />
                    <Route path="edit/:id" element={<Dashboard children={<UpdatePopUp />} />} />
                </Route>
                <Route path="send-bulk-sms" element={<Dashboard children={<SendBulkSms />} />} />
                <Route path="marketing">
                    <Route path="activities" element={<Dashboard children={<MarketingActivities />} />} />
                    <Route path="call-tasks" element={<Dashboard children={<CallTasks />} />} />
                    <Route path="campaigns" element={<Dashboard children={<MarketingCampaigns />} />} />
                    <Route path="campaigns/:id" element={<Dashboard children={<CampaignReport />} />} />
                    <Route path="gold-upgrade" element={<Dashboard children={<GoldUpgradeCandidates />} />} />
                </Route>
                <Route path="world-cup-teams" element={<Dashboard children={<WorldCupTeams />} />} />
                <Route path="world-cup-participants" element={<Dashboard children={<WorldCupParticipants />} />} />
                <Route path="user-score-logs" element={<Dashboard children={<UserScoreLogs />} />} />
                <Route path="user-score-logs/:userId" element={<Dashboard children={<UserScoreDetail />} />} />
                <Route path={'deposit-settings'} element={<Dashboard children={<SystemOfflineDepositSettings />} />} />
                <Route path="settings">
                    <Route path="payment-gateways" element={<Dashboard children={<PaymentGatewaysSettings />} />} />
                    <Route path="financial" element={<Dashboard children={<FinancialSettings />} />} />
                    <Route path="integrations" element={<Dashboard children={<IntegrationsSettings />} />} />
                    <Route path="authentication" element={<Dashboard children={<AuthenticationSettings />} />} />
                </Route>
                <Route path="fiats" element={<Dashboard children={<FiatTable />} />} />
                <Route path="track-voucher" element={<Dashboard children={<TrackVoucher />} />} />
                <Route path="deposit-utopia" element={<Dashboard children={<DepositUtopia />} />} />
                <Route path="sell-utopia-manual" element={<Dashboard children={<SellUtopiaManual />} />} />
                <Route path="utopia-vouchers" element={<Dashboard children={<UtopiaVouchers />} />} />
                <Route path="balancer-transactions">
                    <Route path="" element={<Dashboard children={<BalancerTransactions />} />} />
                    <Route path="add" element={<Dashboard children={<BalancerTransactions key="add" openAddOnLoad />} />} />
                    <Route path={':id'} element={<Dashboard children={<EditBalancerTransactionPage />} />} />
                    <Route
                        path="loss-and-profit-report"
                        element={<Dashboard children={<LossAndProfitReportPage />} />}
                    />
                </Route>
            </Route>
            <Route path="*" element={<Navigate to={isLogin() ? '/dashboard/overview' : '/signin'} />} />
        </Routes>
    );
};
